import _ from 'underscore';
import { getDefaultRTEState } from 'shared/lib/rteHelper';
const debug = require('debug')('shoflo:PreloadRTEImages');

const imageLoadedCache = [];
export const imageHeightCache = {};

const imageCacheContainer = document.createElement('div');
imageCacheContainer.style.position = 'absolute';
imageCacheContainer.style.top = '-1000000px';

document.body.appendChild(imageCacheContainer);

/**
 * Preload all images in an item set (in titles, descriptions, notes, and cells)
 *
 * @param itemSetList
 * @param userId
 * @private
 */
const preloadItemSetImages = (itemSetList, userId) => {
  const promises = [];

  itemSetList.itemSets.forEach((itemSet) => {
    const { rowOrder, rows } = itemSet;
    rows.forEach((row) => {
      //dont preload images from rows that aren't in the row order
      if (rowOrder.indexOf(row._id) === -1) return;
      const item = row.item[0];

      promises.push(_preloadRteStateImages(item.rteTitleState));
      promises.push(_preloadRteStateImages(item.rteDescriptionState));

      _.each(item.cells, (cell) => {
        //handle situation where cell rteState is undefined in corrupted shows
        if (!cell) {
          cell = { rteState: getDefaultRTEState() };
        }
        promises.push(_preloadRteStateImages(cell.rteState));
      });

      if (userId && item.userSettings && item.userSettings[userId]) {
        const userSettings = item.userSettings[userId];
        if (userSettings.note && userSettings.note.rteState) {
          promises.push(_preloadRteStateImages(userSettings.note.rteState));
        }
      }
    });
  });

  return Promise.all(promises);
};

/**
 * Preload any images in an rte state object
 *
 * @param rteState
 * @returns {Array}
 * @private
 */
const _preloadRteStateImages = (rteState) => {
  const promises = [];

  if (!rteState) return promises;

  _.each(rteState.entityMap, ({ data, type }) => {
    if (type === 'IMAGE') {
      const { signedSrc, src, s3Key } = data;
      const imgSrc = signedSrc || src;
      const imgKey = s3Key || imgSrc;

      debug('trying to preload image', imgSrc);

      if (imageLoadedCache.indexOf(imgSrc) >= 0) {
        return;
      }

      imageLoadedCache.push(imgSrc);
      const img = new Image();
      if (img.decode) {
        img.src = imgSrc;
        let promise = img
          .decode()
          .then(() => {
            imageHeightCache[imgKey] = {
              naturalHeight: img.naturalHeight,
              naturalWidth: img.naturalWidth,
            };
            imageCacheContainer.appendChild(img);
          })
          .catch(() => {
            debug('preloaded image failed', imgSrc);
          });
        promises.push(promise);
      } else {
        promises.push(
          new Promise((ful) => {
            const img = new Image();
            img.onerror = () => {
              debug('preloaded image failed', imgSrc);
              ful();
            };
            img.onload = () => {
              imageHeightCache[imgKey] = {
                naturalHeight: img.naturalHeight,
                naturalWidth: img.naturalWidth,
              };
              debug('preloaded image', imgSrc);
              ful();
            };
            img.src = imgSrc;
            imageCacheContainer.appendChild(img);
          }),
        );
      }
    }
  });

  return Promise.all(promises);
};

export default preloadItemSetImages;
